import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function HookSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-brand-dark border-y border-slate-800/50" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-brand-card rounded-2xl p-8 sm:p-12 border border-slate-800 relative overflow-hidden" data-id="element-92">
          {/* Decorative accent */}
          <div className="absolute top-0 left-0 w-1 h-full bg-brand-accent" data-id="element-93" />

          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-white mb-8 leading-snug" data-id="element-94">
            ¿Sabes exactamente a dónde fue cada centavo de tu último sueldo?
          </h2>

          <div className="space-y-6 text-slate-300 text-lg leading-relaxed" data-id="element-95">
            <p data-id="element-96">
              La mayoría de los profesionales viven con una{' '}
              <strong className="text-white font-semibold" data-id="element-97">
                "ansiedad financiera"
              </strong>{' '}
              constante porque su dinero simplemente se evapora.
            </p>
            <p data-id="element-98">
              Trabajas duro, pero el día 20 tu cuenta ya está cerca de cero.
            </p>

            <div className="flex items-start gap-4 bg-brand-dark/50 p-6 rounded-lg border border-slate-800 mt-8" data-id="element-99">
              <AlertCircle className="w-6 h-6 text-brand-accent shrink-0 mt-1" data-id="element-100" />
              <p className="text-white font-medium italic" data-id="element-101">
                No necesitas un contador ni fórmulas complejas. Necesitas un
                SISTEMA DE ORDEN. Uno que puedas implementar en una tarde y que
                trabaje por ti de forma automática el resto del mes.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}